module.exports = __webpack_public_path__ + "img/full0-min.944ac520.png";